import type React from 'react';

import type { AlineSelection } from '@aline/common';
import type { Editor } from 'slate';
import type { EditorFocus } from 'src/types/general';

export interface UpdateContext {
  pendingCheckboxOptionLabelKeys: Set<string>;
  setEditorOnChangeCounter: React.Dispatch<React.SetStateAction<number>>;
  setSelection: React.Dispatch<React.SetStateAction<AlineSelection | null>>;
}

export interface EditorTabState {
  tabId: UUID;
}

const weakMaps = {
  EDITOR_FOCUS: new WeakMap<Editor, EditorFocus>(),
  EDITOR_TO_INPUT_HANDLER: new WeakMap<Editor, HTMLElement>(),
  EDITOR_TO_TAB_STATE: new WeakMap<Editor, EditorTabState>(),
  EDITOR_TO_UPDATE_CONTEXT: new WeakMap<Editor, UpdateContext>(),
  IS_READ_ONLY: new WeakMap<Editor, boolean>(),
};

export default weakMaps;
